import { render, staticRenderFns } from "./CustomerReturnDeliveryView.vue?vue&type=template&id=362b8c92&"
import script from "./CustomerReturnDeliveryView.vue?vue&type=script&lang=ts&"
export * from "./CustomerReturnDeliveryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomerReturnDeliveryView.vue"
export default component.exports